/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plusonescount2Inputs */

const en_plusonescount2 = /** @type {(inputs: Plusonescount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus-ones`)
};

const de_plusonescount2 = /** @type {(inputs: Plusonescount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begleitpersonen`)
};

/**
* | output |
* | --- |
* | "Plus-ones" |
*
* @param {Plusonescount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plusonescount2 = /** @type {((inputs?: Plusonescount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plusonescount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plusonescount2(inputs)
	return de_plusonescount2(inputs)
});
export { plusonescount2 as "plusOnesCount" }